import './Charts.css';

const ChartContainer = ({
  children,
  isLoading = false,
  error = null,
  hasData = true,
  loadingText = '차트를 불러오는 중...',
  errorText = '차트를 불러오는데 실패했습니다',
  noDataText = '표시할 데이터가 없습니다',
  height = '300px',
  className = ''
}) => {
  if (isLoading) {
    return (
      <div 
        className={`chart-wrapper chart-loading ${className}`}
        style={{ height }}
      >
        <div className="loading-spinner"></div>
        <span className="text-b1-400 text-base">{loadingText}</span>
      </div>
    );
  }

  // if (error) {
  //   return (
  //     <div 
  //       className={`chart-wrapper chart-error ${className}`}
  //       style={{ height }}
  //     >
  //       <div className="error-icon">⚠️</div>
  //       <div>
  //         <div className="text-b1-400 text-base">{errorText}</div>
  //         {error.message && (
  //           <div style={{ fontSize: '0.9rem', marginTop: '4px' }}>
  //             <span className="text-b1-400 text-base">{error.message}</span>
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //   );
  // }

  // if (!hasData) {
  //   return (
  //     <div 
  //       className={`chart-wrapper chart-no-data ${className} flex align-center justify-center`}
  //       style={{ height }}
  //     >
  //       <div className="no-data-icon">📊</div>
  //       <span className="text-b1-400 text-base">{noDataText}</span>
  //     </div>
  //   );
  // }

  return (
    <div className={`${className}`} style={{ height }}>
      {children}
    </div>
  );
};

export default ChartContainer;
